import { render, staticRenderFns } from "./LaudoCroqui.vue?vue&type=template&id=6586c052&scoped=true&lang=pug"
import script from "./LaudoCroqui.vue?vue&type=script&lang=js"
export * from "./LaudoCroqui.vue?vue&type=script&lang=js"
import style0 from "./LaudoCroqui.vue?vue&type=style&index=0&id=6586c052&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6586c052",
  null
  
)

export default component.exports